import React from "react";
import Styles from "./AssetImg.module.scss";

type Props = {
	img: string,
	name: string,

	isWaiting?: boolean
	preview?: boolean
}

const AssetImg = (props: Props) => (
	<div
		className={props?.preview ? Styles.imgPreviewContainer : Styles.imgBigContainer}>

		<img
			className={Styles.img}
			src={props.img}
			alt={props.name}
		/>
	</div>
)

export default AssetImg;
